class Search extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.articles_container = this.querySelector(".search--articles"),
        this.article_page_combination = "",
        this.current_width = window.innerWidth,
        this.link_selector = `a[href='${theme.urls.search}']`,
        this.loading = this.querySelector(".search--loading"),
        this.num_loaded_views = 0,
        this.num_pending_views = 0,
        this.products_container = this.querySelector(".search--products"),
        this.search_trigger = document.querySelector('[data-trigger="search-modal"]'),
        this.show_articles = "true" === this.getAttribute("data-show-articles"),
        this.show_pages = "true" === this.getAttribute("data-show-pages"),
        this.text_box = this.querySelector(".search--textbox"),
        this.typing_timer = null,
        this.view = this.getAttribute("data-view"),
        this.show_articles && this.show_pages ? this.article_page_combination = "article,page" : this.show_articles ? this.article_page_combination = "article" : this.show_pages && (this.article_page_combination = "page"),
        this.load()
    }
    load() {
        "modal" === this.view ? (this.updateLinks(),
        this.updateLinksListener(),
        this.listenForKeyEntered()) : this.view.includes("product") ? (this.updateProductsListener(),
        this.resizeProductListener(),
        this.matchProductHeights(),
        theme.settings.hover_image_enabled && "template-product" === this.view && this.loadHoverImages()) : "template-article" === this.view && (this.resizeArticleListener(),
        this.matchArticleHeights())
    }
    updateLinks() {
        this.links = {
            main: theme.off_canvas.main_content.querySelectorAll(this.link_selector),
            right: theme.off_canvas.right_sidebar.querySelectorAll(this.link_selector),
            left: theme.off_canvas.left_sidebar.querySelectorAll(this.link_selector)
        },
        this.resetLinks(),
        this.searchLinks()
    }
    resetLinks() {
        for (const t in this.links)
            this.links[t].off("click")
    }
    searchLinks() {
        this.links.main.length && this.links.main.on("click", t=>{
            this.search_trigger.click(),
            this.onOpen(),
            t.preventDefault(),
            t.stopPropagation()
        }
        ),
        this.links.right.length && this.links.right.on("click", t=>{
            theme.off_canvas.closeRight(),
            setTimeout(()=>{
                this.search_trigger.click(),
                this.onOpen()
            }
            , 450),
            t.preventDefault(),
            t.stopPropagation()
        }
        ),
        this.links.left.length && this.links.left.on("click", t=>{
            theme.off_canvas.closeLeft(),
            setTimeout(()=>{
                this.search_trigger.click(),
                this.onOpen()
            }
            , 450),
            t.preventDefault(),
            t.stopPropagation()
        }
        )
    }
    updateLinksListener() {
        window.on("theme:search:updateLinks", ()=>this.updateLinks())
    }
    onOpen() {
        window.scrollTo(0, 0),
        this.text_box.focus();
        var t = this.text_box.value;
        this.text_box.value = "",
        this.text_box.value = t,
        this.text_box.trigger("keyup")
    }
    listenForKeyEntered() {
        this.text_box.setAttribute("autocomplete", "off"),
        this.text_box.on("keyup paste", t=>{
            clearTimeout(this.typing_timer);
            const e = t.target.value;
            if (e.length < 2 && "paste" !== t.type)
                return this.toggleView(!1, !0),
                !1;
            this.toggleView(!0, !0),
            this.typing_timer = setTimeout(()=>{
                clearTimeout(this.typing_timer),
                this.show_articles || this.show_pages ? (this.num_pending_views = 2,
                this.getResults(`view=ajax-article-page&type=${this.article_page_combination}&q=${e}*`, "article")) : this.num_pending_views = 1,
                this.getResults(`view=ajax-product&type=product&q=${e}*`, "product")
            }
            , 750)
        }
        )
    }
    async getResults(t, e) {
        this.toggleView(!0, !1);
        const i = await fetch(theme.urls.search + "?" + t);
        if (!i.ok)
            throw new Error(i.statusText);
        t = await i.text(),
        t = theme.utils.parseHtml(t);
        this.num_loaded_views += 1,
        "product" === e ? (this.products_container.innerHTML = "",
        this.products_container.appendChild(t),
        this.matchProductHeights(),
        this.loadHoverImages(),
        this.refineLinkListener()) : "article" === e && (this.articles_container.innerHTML = "",
        this.articles_container.appendChild(t)),
        this.num_loaded_views === this.num_pending_views && (this.toggleView(!1, !0),
        this.num_loaded_views = 0)
    }
    toggleView(toggle_load, toggle_display) {
      if (toggle_load) {
        this.loading ? this.loading.style.display = 'block' : null;
      } else if (this.loading) {
        this.loading ? this.loading.style.display = 'none' : null;
      }

      if (toggle_display) {
        this.products_container ? this.products_container.style.opacity = '1' : null;
        this.articles_container ? this.articles_container.style.opacity = '1' : null;
      } else {
        this.products_container ? this.products_container.style.opacity = '0' : null;
        this.articles_container ? this.articles_container.style.opacity = '0' : null;
      }
    }
    updateProductsListener() {
        window.on("theme:navigation:productsUpdated", ()=>{
            this.matchProductHeights(),
            theme.settings.hover_image_enabled && "template-product" === this.view && this.loadHoverImages()
        }
        )
    }
    matchProductHeights() {
        theme.utils.matchImageHeights(this.products_container, this.products_container.querySelectorAll(".product--root"), ".product--image-wrapper")
    }
    loadHoverImages() {
        this.querySelectorAll(".product--hover-image").forEach(e=>{
            theme.utils.imagesLoaded(e, ()=>{
                const t = e.closest('[data-hover-image="true"]');
                t && t.setAttribute("data-hover-image", "loaded")
            }
            )
        }
        )
    }
    refineLinkListener() {
        this.querySelectorAll(".search--refine-link").on("click", t=>{
            t = t.target.getAttribute("data-url");
            t === "" + location.pathname + location.search ? (window.trigger("theme:modal:close"),
            setTimeout(()=>document.querySelector('[data-toggle-menu="refine-filter"]').click(), 250)) : location.href = t + "#filter--open"
        }
        )
    }
    resizeProductListener() {
        window.on("resize.Search", theme.utils.debounce(100, ()=>{
            this.current_width !== window.innerWidth && (this.matchProductHeights(),
            this.current_width = window.innerWidth)
        }
        ))
    }
    matchArticleHeights() {
        theme.utils.matchImageHeights(this.articles_container, this.articles_container.querySelectorAll(".article--item"), ".article--item--image")
    }
    resizeArticleListener() {
        window.on("resize.Search", theme.utils.debounce(100, ()=>{
            this.current_width !== window.innerWidth && (this.matchArticleHeights(),
            this.current_width = window.innerWidth)
        }
        ))
    }
}
customElements.define("search-root", Search);
